import { Horizontal, Texto } from '@gravitate-js/excalibrr'
import { Flex } from 'antd'
import type { PropsWithChildren, ReactNode } from 'react'

type TemplateHeaderProps = {
  actions?: ReactNode
  title?: string
} & PropsWithChildren

export const TemplateHeader = ({ title, actions, children }: TemplateHeaderProps) => (
  <Flex gap={8} vertical className='template-header'>
    <Horizontal justifyContent='space-between' alignItems='center'>
      <Texto category='h4'>{title}</Texto>
      <Horizontal gap={8}>{actions}</Horizontal>
    </Horizontal>
    {children}
  </Flex>
)
